export const seperateTextByCapital = (text) => {
  const res = text.replace(/([A-Z])/g, ' $1').trim()
  return res.replace('Legacy ', '').replace('legacy', '')
}
